import React from 'react';
// icons
import { MdClose } from 'react-icons/md';

import styled from 'styled-components';

// styles
import aampeTheme from '../../constants/aampeTheme';

interface ModalProps {
    handleClose: any;
    title?: string;
}

const LearnModal: React.FC<React.PropsWithChildren<ModalProps>> = ({
    handleClose,
    children,
    title,
}) => {
    return (
        <BackDrop>
            <Modal>
                <Menu>
                    <Title>{title}</Title>
                    <CloseButton onClick={handleClose} />
                </Menu>
                <Content>{children}</Content>
            </Modal>
        </BackDrop>
    );
};

export default LearnModal;

const BackDrop = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
    background: 'linear-gradient(180deg,rgba(38,50,56,.5),rgba(38,50,56,.5))',
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    width: '100%',
    height: '100%',
});

const Modal = styled.div({
    width: 'fit-content',
    maxWidth: '1400px',
    // minWidth: '80%',
    borderRadius: aampeTheme.borderRadius.default,
    overflow: 'hidden',
    maxHeight: '90vh',
});

const Content = styled.div({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
});

const Menu = styled.div({
    backgroundColor: aampeTheme.colors.solidA01,
    height: '40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: aampeTheme.spacing(2),
    padding: aampeTheme.spacing(0, 1),
});

const CloseButton = styled(MdClose)`
    color: #fff;
    cursor: pointer;
    margin-left: auto;
`;

const Title = styled.span({
    color: aampeTheme.colors.white,
    fontSize: '18px',
    fontWeight: 600,
    paddingLeft: aampeTheme.spacing(2),
});
